export function messageReturnFinishedEvent(params) {
    return new CustomEvent("growtypeChatMessageReturnFinished", {
        detail: params
    });
}
